/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/NextAction/Content"
  
}) {
let payorsValueData = fromData.useDataValue({ viewPath,
context: 'payors',
})
let selectedPayorIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'payor_id',
})
let aggregateData = fromHelpers.isLast(payorsValueData, selectedPayorIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 data="payors"
 data="selected.payor_id"
 aggregate="helpers.js isLast"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="View next contract"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}